import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getFormattedNumber } from "@utils";
import { FirstTopupBonusIcon } from '@assets';
import { ModalTopBg } from '@styles';

const Modal = styled(AntModal)`
    .ant-modal-title {
        text-align: center;
        color: ${props => props.theme.primaryColor};
    }

    .ant-modal-content {
        padding-top: 110px !important;
        text-align: center;
        white-space: pre-line;
    }

    .ant-modal-footer {
        text-align: center;
    }

    #top-icon {
        position: absolute;
        top: -16px;
        left: 50%;
        transform: translate(-50%,0);
        width: 120px !important;
    }
`;

const Text = styled.div`
font-size: 14px;
font-weight: 400;
color: #BF3837;
line-height: 1.5;
text-align: center;
padding-top: 8px;
`;

const FirstBonusConfirmModal = ({
    open,
    onBonusAccept,
    handleClose,
    bonus_percent,
    amount,
    exceed_bonus_limit,
    total_amount,
    max_topup_reward,
}) => {
    const { t } = useTranslation();

    const calculateBonus = () => {
        return exceed_bonus_limit ? max_topup_reward : Math.ceil(amount * bonus_percent * 0.01);
    }

    const calculateTotal = () => {
        return exceed_bonus_limit ? total_amount : (amount + calculateBonus());
    }

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            open={open}
            width={320}
            title={t("wallet.firstTopUpBonusTitle")}
            onCancel={handleClose}
            onOk={onBonusAccept}
            okText={t("wallet.accept")}
            cancelText={t("wallet.reject")}
        >
            <ModalTopBg />
            <FirstTopupBonusIcon id='top-icon' />
            {t("wallet.firstTopupBonusMessage", {
                bonus_percent,
                amount: getFormattedNumber(amount),
                bonus_amount: getFormattedNumber(calculateBonus()),
                total: getFormattedNumber(calculateTotal()),
            })}
            <div>
                {exceed_bonus_limit && t("wallet.maxBonusAmount", { max_topup_reward: getFormattedNumber(max_topup_reward) })}
            </div>
            <Text>{t("wallet.bonusAgreeStatement")} </Text>
        </Modal>
    );
}

export default FirstBonusConfirmModal;